export const LICENSE_KIND_OPTIONS = [
  { label: 'Business and Industry', value: 'Business and Industry' },
  { label: 'Early Childhood Education', value: 'Early Childhood Education' },
  { label: 'Elementary', value: 'Elementary' },
  { label: 'Middle School/Junior High', value: 'Middle School/Junior High' },
  { label: 'Secondary', value: 'Secondary' },
  { label: 'Secondary CTE', value: 'Secondary CTE' },
  { label: 'Special', value: 'Special' },
  { label: 'Special Education', value: 'Special Education' },
  { label: 'Special Education - IRC', value: 'Special Education - IRC' },
  { label: 'Substitute', value: 'Substitute' }
];
export const LICENSE_TYPE_OPTIONS = [
  { label: 'Alternative', value: 'Alternative' },
  { label: 'Authorization', value: 'Authorization' },
  { label: 'Emergency', value: 'Emergency' },
  { label: 'Interim', value: 'Interim' },
  { label: 'Professional', value: 'Professional' },
  { label: 'Provisional', value: 'Provisional' },
  { label: 'Qualification', value: 'Qualification' },
  { label: 'Retiree Professional', value: 'Retiree Professional' },
  { label: 'Retiree Standard', value: 'Retiree Standard' },
  { label: 'Standard', value: 'Standard' }
];
// Endorsement options mapped by License Kind
export const ENDORSEMENT_TYPE_OPTIONS: Record<string, { label: string; value: string }[]> = {
  'Business and Industry': [
    { label: 'Accounting and Finance', value: 'Accounting and Finance' },
    { label: 'Advanced Computer Science', value: 'Advanced Computer Science' },
    { label: 'Advanced Manufacturing Technologies', value: 'Advanced Manufacturing Technologies' },
    { label: 'Agricultural Welding, Power and Structure Technology', value: 'Agricultural Welding, Power and Structure Technology' },
    { label: 'Animal Systems', value: 'Animal Systems' },
    { label: 'Automotive Technology', value: 'Automotive Technology' },
    { label: 'Aviation Maintenance Technician', value: 'Aviation Maintenance Technician' },
    { label: 'Aviation Technology', value: 'Aviation Technology' },
    { label: 'Biomedical', value: 'Biomedical' },
    { label: 'Building Trades in Construction Technology', value: 'Building Trades in Construction Technology' },
    { label: 'Business Management', value: 'Business Management' },
    { label: 'Community Health Science', value: 'Community Health Science' },
    { label: 'Cosmetology', value: 'Cosmetology' },
    { label: 'Culinary Arts', value: 'Culinary Arts' },
    { label: 'Cybersecurity', value: 'Cybersecurity' },
    { label: 'Dance Performance', value: 'Dance Performance' },
    { label: 'Dental Science', value: 'Dental Science' },
    { label: 'Design Drafting', value: 'Design Drafting' },
    { label: 'Diesel Technology', value: 'Diesel Technology' },
    { label: 'Digital Game Development', value: 'Digital Game Development' },
    { label: 'Early Childhood Education', value: 'Early Childhood Education' },
    { label: 'Electronic Technology', value: 'Electronic Technology' },
    { label: 'Emergency Medical Technician', value: 'Emergency Medical Technician' },
    { label: 'Emergency Telecommunications', value: 'Emergency Telecommunications' },
    { label: 'Energy Technologies', value: 'Energy Technologies' },
    { label: 'Engineering Foundations', value: 'Engineering Foundations' },
    { label: 'Ethnic Dance', value: 'Ethnic Dance' },
    { label: 'Ethnic Music', value: 'Ethnic Music' },
    { label: 'Family and Consumer Sciences', value: 'Family and Consumer Sciences' },
    { label: 'Fashion, Textiles and Design', value: 'Fashion, Textiles and Design' },
    { label: 'Fire Science', value: 'Fire Science' },
    { label: 'Forensic Science', value: 'Forensic Science' },
    { label: 'Graphic Design', value: 'Graphic Design' },
    { label: 'Heating, Ventilation, Air Conditioning and Refrigeration (HVACR)', value: 'Heating, Ventilation, Air Conditioning and Refrigeration (HVACR)' },
    { label: 'Hospitality and Tourism', value: 'Hospitality and Tourism' },
    { label: 'Human and Social Services', value: 'Human and Social Services' },
    { label: 'Industrial Maintenance', value: 'Industrial Maintenance' },
    { label: 'Information Technology Networking', value: 'Information Technology Networking' },
    { label: 'Law Enforcement', value: 'Law Enforcement' },
    { label: 'Logistics Management', value: 'Logistics Management' },
    { label: 'Marketing', value: 'Marketing' },
    { label: 'Medical Assisting', value: 'Medical Assisting' },
    { label: 'Metalworking', value: 'Metalworking' },
    { label: 'Military Science JROTC', value: 'Military Science JROTC' },
    { label: 'Mining Technology and Sciences', value: 'Mining Technology and Sciences' },
    { label: 'Multimedia Communications', value: 'Multimedia Communications' },
    { label: 'Nursing Assistant', value: 'Nursing Assistant' },
    { label: 'Office Management', value: 'Office Management' },
    { label: 'Plant Systems', value: 'Plant Systems' },
    { label: 'Practical Nursing', value: 'Practical Nursing' },
    { label: 'Radio Production', value: 'Radio Production' },
    { label: 'Sports Medicine', value: 'Sports Medicine' },
    { label: 'Teaching and Training', value: 'Teaching and Training' },
    { label: 'Theatre Technology', value: 'Theatre Technology' },
    { label: 'Video Production', value: 'Video Production' },
    { label: 'Web Design and Development', value: 'Web Design and Development' },
    { label: 'Welding Technology', value: 'Welding Technology' }
  ],
  'Early Childhood Education': [
    { label: 'All Early Childhood Subjects', value: 'All Early Childhood Subjects' }
  ],
  'Elementary': [
    { label: 'All Elementary Subjects', value: 'All Elementary Subjects' },
    { label: 'Elementary/Middle School Physical Education', value: 'Elementary/Middle School Physical Education' }
  ],
  'Middle School/Junior High': [
    { label: 'Art', value: 'Art' },
    { label: 'Computer Science', value: 'Computer Science' },
    { label: 'English', value: 'English' },
    { label: 'Mathematics', value: 'Mathematics' },
    { label: 'Music Instrumental', value: 'Music Instrumental' },
    { label: 'Music Instrumental and Vocal', value: 'Music Instrumental and Vocal' },
    { label: 'Music Vocal', value: 'Music Vocal' },
    { label: 'Science', value: 'Science' },
    { label: 'Social Science', value: 'Social Science' },
    { label: 'World Language - Arabic', value: 'World Language - Arabic' },
    { label: 'World Language - Chinese (Mandarin)', value: 'World Language - Chinese (Mandarin)' },
    { label: 'World Language - French', value: 'World Language - French' },
    { label: 'World Language - German', value: 'World Language - German' },
    { label: 'World Language - Hebrew', value: 'World Language - Hebrew' },
    { label: 'World Language - Italian', value: 'World Language - Italian' },
    { label: 'World Language - Japanese', value: 'World Language - Japanese' },
    { label: 'World Language - Korean', value: 'World Language - Korean' },
    { label: 'World Language - Latin', value: 'World Language - Latin' },
    { label: 'World Language - Russian', value: 'World Language - Russian' },
    { label: 'World Language - Spanish', value: 'World Language - Spanish' },
    { label: 'World Language - Tagalog', value: 'World Language - Tagalog' },
    { label: 'World Language - Turkish', value: 'World Language - Turkish' }
  ],
  'Secondary': [
    { label: 'Anthropology', value: 'Anthropology' },
    { label: 'Art', value: 'Art' },
    { label: 'Biological Science', value: 'Biological Science' },
    { label: 'Biology', value: 'Biology' },
    { label: 'Botany', value: 'Botany' },
    { label: 'Chemistry', value: 'Chemistry' },
    { label: 'Composition and Rhetoric', value: 'Composition and Rhetoric' },
    { label: 'Computer Science Education', value: 'Computer Science Education' },
    { label: 'Dance', value: 'Dance' },
    { label: 'Dramatic or Theatrical Arts', value: 'Dramatic or Theatrical Arts' },
    { label: 'Earth Science', value: 'Earth Science' },
    { label: 'Economics', value: 'Economics' },
    { label: 'English', value: 'English' },
    { label: 'English as a Second Language', value: 'English as a Second Language' },
    { label: 'English/American Literature', value: 'English/American Literature' },
    { label: 'Environmental Science', value: 'Environmental Science' },
    { label: 'General Science', value: 'General Science' },
    { label: 'Geography', value: 'Geography' },
    { label: 'Geology', value: 'Geology' },
    { label: 'Health Education', value: 'Health Education' },
    { label: 'History of the US and World', value: 'History of the US and World' },
    { label: 'Journalism and Communication', value: 'Journalism and Communication' },
    { label: 'Linguistics', value: 'Linguistics' },
    { label: 'Mathematics Major', value: 'Mathematics Major' },
    { label: 'Mathematics Minor', value: 'Mathematics Minor' },
    { label: 'Music', value: 'Music' },
    { label: 'Music Instrumental', value: 'Music Instrumental' },
    { label: 'Music Instrumental and Vocal', value: 'Music Instrumental and Vocal' },
    { label: 'Music Vocal', value: 'Music Vocal' },
    { label: 'Physical Education', value: 'Physical Education' },
    { label: 'Physical Science', value: 'Physical Science' },
    { label: 'Physics', value: 'Physics' },
    { label: 'Physiology', value: 'Physiology' },
    { label: 'Political Science', value: 'Political Science' },
    { label: 'Psychology', value: 'Psychology' },
    { label: 'Reading', value: 'Reading' },
    { label: 'Social Studies', value: 'Social Studies' },
    { label: 'Sociology', value: 'Sociology' },
    { label: 'Speech', value: 'Speech' },
    { label: 'Speech and Drama', value: 'Speech and Drama' },
    { label: 'World Language - Arabic', value: 'World Language - Arabic' },
    { label: 'World Language - Chinese (Mandarin)', value: 'World Language - Chinese (Mandarin)' },
    { label: 'World Language - French', value: 'World Language - French' },
    { label: 'World Language - German', value: 'World Language - German' },
    { label: 'World Language - Hebrew', value: 'World Language - Hebrew' },
    { label: 'World Language - Italian', value: 'World Language - Italian' },
    { label: 'World Language - Japanese', value: 'World Language - Japanese' },
    { label: 'World Language - Korean', value: 'World Language - Korean' },
    { label: 'World Language - Latin', value: 'World Language - Latin' },
    { label: 'World Language - Russian', value: 'World Language - Russian' },
    { label: 'World Language - Spanish', value: 'World Language - Spanish' },
    { label: 'World Language - Tagalog', value: 'World Language - Tagalog' },
    { label: 'World Language - Turkish', value: 'World Language - Turkish' },
    { label: 'Zoology', value: 'Zoology' }
  ],
  'Secondary CTE': [
    { label: 'Agricultural Education', value: 'Agricultural Education' },
    { label: 'Business Education', value: 'Business Education' },
    { label: 'Communications and Media Education', value: 'Communications and Media Education' },
    { label: 'Computer Science Education', value: 'Computer Science Education' },
    { label: 'Engineering and Technology Education', value: 'Engineering and Technology Education' },
    { label: 'Family and Consumer Sciences Education', value: 'Family and Consumer Sciences Education' },
    { label: 'Hospitality and Tourism Education', value: 'Hospitality and Tourism Education' },
    { label: 'Industrial Arts', value: 'Industrial Arts' },
    { label: 'Marketing Education', value: 'Marketing Education' },
    { label: 'Theater Education', value: 'Theater Education' }
  ],
  'Special': [
    { label: 'Advanced Computer Science', value: 'Advanced Computer Science' },
    { label: 'American Sign Language', value: 'American Sign Language' },
    { label: 'Art', value: 'Art' },
    { label: 'Audiological Services', value: 'Audiological Services' },
    { label: 'Bilingual', value: 'Bilingual' },
    { label: 'Cultural Competency', value: 'Cultural Competency' },
    { label: 'Cultural Competency Specialist', value: 'Cultural Competency Specialist' },
    { label: 'Dance', value: 'Dance' },
    { label: 'Driver Education', value: 'Driver Education' },
    { label: 'English Language Acquisition Dev (ELAD w practicum)', value: 'English Language Acquisition Dev (ELAD w practicum)' },
    { label: 'English Language Acquisition Dev Specialist', value: 'English Language Acquisition Dev Specialist' },
    { label: 'Great Basin Language', value: 'Great Basin Language' },
    { label: 'Introductory Computer Science', value: 'Introductory Computer Science' },
    { label: "Jobs for America's Graduates (JAG)", value: "Jobs for America's Graduates (JAG)" },
    { label: 'JROTC', value: 'JROTC' },
    { label: 'Music', value: 'Music' },
    { label: 'Music Therapist', value: 'Music Therapist' },
    { label: 'Navajo Language and Government of the Navajo Nation', value: 'Navajo Language and Government of the Navajo Nation' },
    { label: 'Occupational Therapy', value: 'Occupational Therapy' },
    { label: 'Occupational Therapy Assistant', value: 'Occupational Therapy Assistant' },
    { label: 'Physical Education', value: 'Physical Education' },
    { label: 'Physical Education and Health', value: 'Physical Education and Health' },
    { label: 'Physical Therapist Assistant', value: 'Physical Therapist Assistant' },
    { label: 'Physical Therapy', value: 'Physical Therapy' },
    { label: 'Program Administrator', value: 'Program Administrator' },
    { label: 'Reading', value: 'Reading' },
    { label: 'Reading Specialist', value: 'Reading Specialist' },
    { label: 'Registered Apprentice', value: 'Registered Apprentice' },
    { label: 'School Administrator', value: 'School Administrator' },
    { label: 'School Counselor', value: 'School Counselor' },
    { label: 'School Library Media Specialist', value: 'School Library Media Specialist' },
    { label: 'School Mental Health Professional', value: 'School Mental Health Professional' },
    { label: 'School Nurse', value: 'School Nurse' },
    { label: 'School Psychologist', value: 'School Psychologist' },
    { label: 'School Psychologist Assistant', value: 'School Psychologist Assistant' },
    { label: 'School Social Worker', value: 'School Social Worker' },
    { label: 'Social, Emotional, and Academic Development', value: 'Social, Emotional, and Academic Development' },
    { label: 'Social, Emotional, and Academic Development Specialist', value: 'Social, Emotional, and Academic Development Specialist' },
    { label: 'STEM', value: 'STEM' },
    { label: 'World Language - Arabic', value: 'World Language - Arabic' },
    { label: 'World Language - Chinese (Mandarin)', value: 'World Language - Chinese (Mandarin)' },
    { label: 'World Language - French', value: 'World Language - French' },
    { label: 'World Language - German', value: 'World Language - German' },
    { label: 'World Language - Hebrew', value: 'World Language - Hebrew' },
    { label: 'World Language - Italian', value: 'World Language - Italian' },
    { label: 'World Language - Japanese', value: 'World Language - Japanese' },
    { label: 'World Language - Korean', value: 'World Language - Korean' },
    { label: 'World Language - Latin', value: 'World Language - Latin' },
    { label: 'World Language - Russian', value: 'World Language - Russian' },
    { label: 'World Language - Spanish', value: 'World Language - Spanish' },
    { label: 'World Language - Tagalog', value: 'World Language - Tagalog' },
    { label: 'World Language - Turkish', value: 'World Language - Turkish' }
  ],
  'Special Education': [
    { label: 'Adapted Physical Education', value: 'Adapted Physical Education' },
    { label: 'Alternative Education', value: 'Alternative Education' },
    { label: 'Autism Spectrum Disorder', value: 'Autism Spectrum Disorder' },
    { label: 'Early Childhood Developmentally Delayed', value: 'Early Childhood Developmentally Delayed' },
    { label: 'Generalist', value: 'Generalist' },
    { label: 'Gifted and Talented Education', value: 'Gifted and Talented Education' },
    { label: 'Hearing Impairments', value: 'Hearing Impairments' },
    { label: 'Intellectual Disabilities', value: 'Intellectual Disabilities' },
    { label: 'Orientation and Mobility', value: 'Orientation and Mobility' },
    { label: 'Speech and Language Impairments', value: 'Speech and Language Impairments' },
    { label: 'Visual Impairments', value: 'Visual Impairments' }
  ],
  'Special Education - IRC': [
    { label: 'Adapted Physical Education', value: 'Adapted Physical Education' },
    { label: 'Autism Spectrum Disorder', value: 'Autism Spectrum Disorder' },
    { label: 'Early Childhood Developmentally Delayed', value: 'Early Childhood Developmentally Delayed' },
    { label: 'Generalist', value: 'Generalist' },
    { label: 'Hearing Impairments', value: 'Hearing Impairments' },
    { label: 'Intellectual Disabilities', value: 'Intellectual Disabilities' },
    { label: 'Visual Impairments', value: 'Visual Impairments' }
  ],
  'Substitute': [
    { label: 'Emergency Substitute', value: 'Emergency Substitute' },
    { label: 'Substitute', value: 'Substitute' }
  ]
};

export const SEARCH_INFO_FIELDS = [
  { label: 'Name', fieldName: 'name', datatype: 'text', placeholder: 'Enter Educator Name' },
  { label: 'Date of Birth', fieldName: 'dob', datatype: 'daterange', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false },
  { label: 'SSN / ITIN', fieldName: 'ssn', datatype: 'text', placeholder: 'Enter SSN or ITIN', pattern: 'onlyNumber', minLength: 4 },
  { label: 'Email', fieldName: 'email', datatype: 'text', placeholder: 'user@example.com', validation: ['email'] },
  { label: 'Prior Name', fieldName: 'prior_name', datatype: 'text', placeholder: 'Enter Prior First or Last Name' },
  { label: 'Phone Number', fieldName: 'phone_number', datatype: 'text', placeholder: 'Enter Phone Number', pattern: 'onlyNumber' },
  { label: 'District Employed', fieldName: 'district_employed', datatype: 'multiselectdropdown', placeholder: 'Select District Employed', options: [] },
  { label: 'Individual ID', fieldName: 'individual_id', datatype: 'text', placeholder: 'Enter Individual ID', pattern: 'onlyNumber' },
  { label: 'License Number', fieldName: 'license_number', datatype: 'text', placeholder: 'Enter License Number', pattern: 'onlyNumber' },
  { label: 'License Type', fieldName: 'license_type', datatype: 'multiselectdropdown', placeholder: 'Select License Type', options: [] },
  { label: 'License Kind', fieldName: 'license_kind', datatype: 'multiselectdropdown', placeholder: 'Select License Kind', options: LICENSE_KIND_OPTIONS },
  { label: 'Endorsement Type', fieldName: 'endorsement_type', datatype: 'multiselectdropdown', placeholder: 'Select Endorsement', options: [], disabled: false },
  { label: 'License Effective Date', fieldName: 'license_effective_date', datatype: 'daterange', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false },
  { label: 'License Expiration Date', fieldName: 'license_expiration_date', datatype: 'daterange', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false },
  { label: 'Endorsement Expiration Date', fieldName: 'endorsement_expiration_date', datatype: 'daterange', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false }
];
export const SEARCH_GRID_COLUMNS = [
  { key: 'educator_name', dataField: 'educator_name', caption: 'Name', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
  { key: 'dob', dataField: 'dob', caption: 'Date of Birth', allowFiltering: true, dataType: 'date', filterOperations: ['=', '<', '>'], editorOptions: { displayFormat: 'MM/dd/yyyy', inputAttr: { inputmode: 'numeric', pattern: '[0-9/]*' } }, allowSearch: { isSearchEnable: true, type: 'date' } },
  { key: 'ssn', dataField: 'ssn', caption: 'SSN / ITIN', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
  { key: 'license_number', dataField: 'license_number', caption: 'License Number', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
  { key: 'email', dataField: 'email', caption: 'Email', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
  { key: 'license_effective_date', dataField: 'license_effective_date', caption: 'License Effective Date', allowFiltering: true, dataType: 'date', filterOperations: ['=', '<', '>'], editorOptions: { displayFormat: 'MM/dd/yyyy', inputAttr: { inputmode: 'numeric', pattern: '[0-9/]*' } }, allowSearch: { isSearchEnable: true, type: 'date' } },
  { key: 'license_expiration_date', dataField: 'license_expiration_date', caption: 'License Expiration Date', allowFiltering: true, dataType: 'date', filterOperations: ['=', '<', '>'], editorOptions: { displayFormat: 'MM/dd/yyyy', inputAttr: { inputmode: 'numeric', pattern: '[0-9/]*' } }, allowSearch: { isSearchEnable: true, type: 'date' } }
];
